import { type ReactNode } from 'react';

import { Box, Paper, type PaperProps } from '@material-ui/core';

type FloatingCardProps = PaperProps & {
  children?: ReactNode;
  p?: number | string;
  pt?: number | string;
  px?: number | string;
  py?: number | string;
  overflow?: 'hidden' | 'visible';
};

const toNumber = (v: number | string | undefined): number | undefined =>
  typeof v === 'string' ? Number(v) : v;

export const FloatingCard = ({
  children,
  className,
  p = 2,
  pt,
  px,
  py,
  overflow = 'hidden',
  style,
  ...props
}: FloatingCardProps) => (
  <Paper
    elevation={0}
    variant="outlined"
    style={{
      borderRadius: 6,
      overflow,
      boxShadow: '0 1px 2px rgba(0,0,0,0.04), 0 4px 12px rgba(0,0,0,0.08)',
      ...style,
    }}
    className={className}
    {...props}
  >
    <Box p={toNumber(p)} pt={toNumber(pt)} px={toNumber(px)} py={toNumber(py)}>
      {children}
    </Box>
  </Paper>
);

export const ToolbarCard = (props: FloatingCardProps) => (
  <FloatingCard p={0.25} overflow="visible" {...props} />
);
